import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

const StyledLink = styled.a`
  ${tw`text-slate-500 text-xs`};

  &:hover {
    ${tw`text-slate-800`};
  }
`;

interface Props {
  href?: string;
  children?: ReactNode;
}

const Link: FC<Props> = ({ href, children }) => (
  <StyledLink href={href}>{children}</StyledLink>
);

export default Link;
